var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2575 13.2696C22.2575 13.8703 21.7705 14.3573 21.1698 14.3573H5.94309C5.34241 14.3573 4.85547 13.8703 4.85547 13.2696C4.85547 12.6689 5.34241 12.182 5.94309 12.182H21.1698C21.7705 12.182 22.2575 12.6689 22.2575 13.2696Z",
    fill: "#2B343E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2379 5.97481C13.6627 6.39955 13.6627 7.0882 13.2379 7.51294L7.48123 13.2696L13.2379 19.0263C13.6627 19.4511 13.6627 20.1397 13.2379 20.5644C12.8132 20.9892 12.1245 20.9892 11.6998 20.5644L5.17403 14.0387C4.74928 13.614 4.74928 12.9253 5.17403 12.5006L11.6998 5.97481C12.1245 5.55006 12.8132 5.55006 13.2379 5.97481Z",
    fill: "#2B343E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.d4ce24223e5735d750d035d0152b63d4.svg";
export { ForwardRef as ReactComponent };